import { Key } from 'ts-key-enum';

type Char
    = 'a' | 'b' | 'c' | 'd' | 'e' | 'f' | 'g' | 'h' | 'i' | 'j' | 'k' | 'l' | 'm' | 'n' | 'o' | 'p' | 'q' | 'r' | 's' | 't' | 'u' | 'v' | 'w' | 'x' | 'y' | 'z'
    | 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H' | 'I' | 'J' | 'K' | 'L' | 'M' | 'N' | 'O' | 'P' | 'Q' | 'R' | 'S' | 'T' | 'U' | 'V' | 'W' | 'X' | 'Y' | 'Z'
    | '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '-' | '=' | '!' | '@' | '#' | '$' | '%' | '^' | '&' | '*' | '(' | ')' | '_' | '+' | '[' | ']'
    | '{' | '}' | '\\' | '|' | ';' | ':' | "'" | '"' | '`' | '~' | ',' | '.' | '<' | '>' | '/' | '?' | ' ';

type IKeyboardEvents = {
    [key in keyof typeof Key | Char]?: (e: React.KeyboardEvent) => boolean | void;
}

export function keymap<Element extends HTMLElement = HTMLElement>(events: IKeyboardEvents) {
    return function onKeyDown(e: React.KeyboardEvent<Element>) {
        let handler = events[e.key as Key];

        if (handler && handler(e) !== false)
            e.preventDefault();
    }
}
